export function AButton({children, className, ...props}) {
    return (
        <a className={`px-4 py-2 rounded ${className}`} {...props}>
            {children}
        </a>
    );
}